import { Container, Card, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  FaExclamationTriangle,
  FaDesktop,
  FaEye,
  FaClock,
  FaShieldAlt,
  FaCheckCircle,
  FaBolt,
  FaWifi
} from "react-icons/fa";

const Instructions = () => {
  const navigate = useNavigate();

  const handleProceed = () => {
    const session = localStorage.getItem("session_id");

    if (!session) {
      navigate("/signup");
    } else {
      navigate("/enter-code");
    }
  };

  return (
    <div className="instruction-page">

      <Container>

        {/* HEADER */}
        <div className="text-center mb-5">
          <div className="icon-box mb-3">
            <FaExclamationTriangle size={28} />
          </div>

          <h1 className="fw-bold">Exam Instructions</h1>
          <p className="text-muted">
            Please read carefully before starting your exam.
          </p>
        </div>

        {/* PROCTORING RULES */}
        <Card className="main-card mb-4">
          <Card.Body>

            <h5 className="fw-bold mb-4">
              <FaShieldAlt className="me-2 text-warning" />
              Proctoring Rules
            </h5>

            {[
              {
                icon: <FaDesktop />,
                text: "The exam will run in fullscreen mode. Exiting fullscreen will trigger a warning ."
              },
              {
                icon: <FaEye />,
                text: "Tab switches are monitored. If you try switching the tabs, the exam will be automatically submitted"
              },
              {
                icon: <FaClock />,
                text: "The exam has a strict timer. It will auto-submit when time runs out."
              },
              {
                icon: <FaShieldAlt />,
                text: "Your answers are auto-saved. You can resume if you lose connection."
              }
            ].map((item, i) => (
              <div key={i} className="rule-box">
                <div className="rule-icon">{item.icon}</div>
                <p>{item.text}</p>
              </div>
            ))}

          </Card.Body>
        </Card>

        {/* GENERAL GUIDELINES */}
        <Card className="main-card mb-4">
          <Card.Body>

            <h5 className="fw-bold mb-4">
              <FaBolt className="me-2 text-primary" />
              General Guidelines
            </h5>

            <Row>
              {[
                "Each question has only one correct answer",
                "Navigate between questions freely",
                'Use "Mark for Review" to flag questions',
                "No negative marking",
                "Ensure a stable internet connection",
                "Use a desktop/laptop for best experience"
              ].map((text, i) => (
                <Col md={6} key={i} className="mb-3 d-flex">
                  <FaCheckCircle className="text-success me-2 mt-1" />
                  <span>{text}</span>
                </Col>
              ))}
            </Row>

          </Card.Body>
        </Card>

        {/* PRE-FLIGHT CHECK */}
        <Card className="precheck-card mb-4">
          <Card.Body className="d-flex align-items-center">
            <FaWifi className="me-3 text-primary" size={22} />
            <div>
              <strong>Pre-flight Check</strong>
              <p className="mb-0 text-muted small">
                Ensure stable internet, close unnecessary tabs, and use a laptop/desktop.
              </p>
            </div>
          </Card.Body>
        </Card>

        {/* USER + BUTTON */}
        {/* <div className="text-center">
          <div className="user-badge mb-3">
            ● Logged in as: <strong>user</strong>
          </div>

          <Button className="start-btn px-5 py-3" onClick={handleProceed}>
            Start Exam →
          </Button>
        </div> */}

      </Container>

      {/* CSS */}
      <style>{`
        .instruction-page {
          min-height: 100vh;
          background: linear-gradient(135deg, #eef3f7, #f7f9fb);
          padding: 60px 0;
        }

        .icon-box {
          width: 60px;
          height: 60px;
          margin: auto;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff3cd;
          color: #f59e0b;
        }

        .main-card {
          border-radius: 16px;
          border: none;
          box-shadow: 0 10px 30px rgba(0,0,0,0.08);
          padding: 10px;
        }

        .rule-box {
          display: flex;
          align-items: center;
          background: #f8f9fa;
          border-radius: 12px;
          padding: 15px;
          margin-bottom: 15px;
        }

        .rule-icon {
          width: 45px;
          height: 45px;
          border-radius: 10px;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 15px;
          box-shadow: 0 5px 10px rgba(0,0,0,0.05);
        }

        .rule-box p {
          margin: 0;
          font-size: 14px;
        }

        .precheck-card {
          border-radius: 14px;
          background: #eef6ff;
          border: none;
        }

        .start-btn {
          background: linear-gradient(90deg, #0d6efd, #20c997);
          border: none;
          border-radius: 12px;
          font-weight: 600;
          transition: 0.3s;
        }

        .start-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.15);
        }

        .user-badge {
          display: inline-block;
          padding: 6px 14px;
          background: #e6f9f0;
          border-radius: 20px;
          font-size: 14px;
          color: #198754;
        }
      `}</style>

    </div>
  );
};

export default Instructions;